import { TestDefinition, QuestionType } from '../../types';

// Helper scale 1-7 para PANSS y BPRS
const scale1to7 = [
  { label: '1 - Ausente', value: 1 },
  { label: '2 - Mínimo', value: 2 },
  { label: '3 - Leve', value: 3 },
  { label: '4 - Moderado', value: 4 },
  { label: '5 - Moderado-Severo', value: 5 },
  { label: '6 - Severo', value: 6 },
  { label: '7 - Extremo', value: 7 }
];

export const TESTS_PSICOSIS: TestDefinition[] = [
  {
    id: 'panss',
    code: 'PANSS',
    name: 'Positive and Negative Syndrome Scale',
    category: 'Psicosis',
    description: 'Escala de 30 ítems para evaluar síntomas psicóticos en esquizofrenia. Desarrollada por Kay et al. (1987). Incluye síntomas positivos (7), negativos (7) y psicopatología general (16).',
    questions: [
      // ESCALA POSITIVA (P1-P7)
      {
        id: 'p1',
        text: 'P1. Delirios',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Positivos'
      },
      {
        id: 'p2',
        text: 'P2. Desorganización conceptual',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Positivos'
      },
      {
        id: 'p3',
        text: 'P3. Comportamiento alucinatorio',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Positivos'
      },
      {
        id: 'p4',
        text: 'P4. Excitación',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Positivos'
      },
      {
        id: 'p5',
        text: 'P5. Grandiosidad',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Positivos'
      },
      {
        id: 'p6',
        text: 'P6. Suspicacia/Persecución',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Positivos'
      },
      {
        id: 'p7',
        text: 'P7. Hostilidad',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Positivos'
      },

      // ESCALA NEGATIVA (N1-N7)
      {
        id: 'n1',
        text: 'N1. Embotamiento afectivo',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Negativos'
      },
      {
        id: 'n2',
        text: 'N2. Retraimiento emocional',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Negativos'
      },
      {
        id: 'n3',
        text: 'N3. Contacto pobre',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Negativos'
      },
      {
        id: 'n4',
        text: 'N4. Retraimiento social pasivo/apático',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Negativos'
      },
      {
        id: 'n5',
        text: 'N5. Dificultad en pensamiento abstracto',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Negativos'
      },
      {
        id: 'n6',
        text: 'N6. Falta de espontaneidad y fluidez de conversación',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Negativos'
      },
      {
        id: 'n7',
        text: 'N7. Pensamiento estereotipado',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Síntomas Negativos'
      },

      // PSICOPATOLOGÍA GENERAL (G1-G16)
      {
        id: 'g1',
        text: 'G1. Preocupación somática',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g2',
        text: 'G2. Ansiedad',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g3',
        text: 'G3. Sentimientos de culpa',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g4',
        text: 'G4. Tensión motora',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g5',
        text: 'G5. Manierismos y posturas',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g6',
        text: 'G6. Depresión',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g7',
        text: 'G7. Retardo motor',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g8',
        text: 'G8. Falta de colaboración',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g9',
        text: 'G9. Contenidos inusuales del pensamiento',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g10',
        text: 'G10. Desorientación',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g11',
        text: 'G11. Atención deficiente',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g12',
        text: 'G12. Ausencia de juicio e introspección',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g13',
        text: 'G13. Trastornos de la volición',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g14',
        text: 'G14. Pobre control de impulsos',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g15',
        text: 'G15. Preocupación',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      },
      {
        id: 'g16',
        text: 'G16. Evitación social activa',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Psicopatología General'
      }
    ],
    subscales: [
      {
        name: 'Síntomas Positivos',
        questionIds: ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7'],
        description: 'Delirios, alucinaciones, excitación, grandiosidad, suspicacia, hostilidad'
      },
      {
        name: 'Síntomas Negativos',
        questionIds: ['n1', 'n2', 'n3', 'n4', 'n5', 'n6', 'n7'],
        description: 'Embotamiento afectivo, retraimiento, alogia, apatía, déficits cognitivos'
      },
      {
        name: 'Psicopatología General',
        questionIds: ['g1', 'g2', 'g3', 'g4', 'g5', 'g6', 'g7', 'g8', 'g9', 'g10', 'g11', 'g12', 'g13', 'g14', 'g15', 'g16'],
        description: 'Síntomas generales: ansiedad, depresión, déficits cognitivos, etc.'
      }
    ],
    interpretations: [
      { min: 30, max: 58, label: 'Remisión / Síntomas Mínimos', color: 'bg-green-100 text-green-800' },
      { min: 59, max: 75, label: 'Síntomas Leves', color: 'bg-yellow-100 text-yellow-800' },
      { min: 76, max: 95, label: 'Síntomas Moderados', color: 'bg-orange-100 text-orange-800' },
      { min: 96, max: 116, label: 'Síntomas Marcados', color: 'bg-orange-200 text-orange-900' },
      { min: 117, max: 210, label: 'Síntomas Severos', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'bprs',
    code: 'BPRS',
    name: 'Brief Psychiatric Rating Scale',
    category: 'Psicosis',
    description: 'Escala breve de 18 ítems para evaluación rápida de síntomas psiquiátricos. Desarrollada por Overall y Gorham (1962). Útil para screening y monitoreo de tratamiento.',
    questions: [
      {
        id: 'b1',
        text: '1. Preocupación somática',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b2',
        text: '2. Ansiedad',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b3',
        text: '3. Retraimiento emocional',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b4',
        text: '4. Desorganización conceptual',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b5',
        text: '5. Sentimientos de culpa',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b6',
        text: '6. Tensión',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b7',
        text: '7. Manierismos y posturas',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b8',
        text: '8. Grandiosidad',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b9',
        text: '9. Humor depresivo',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b10',
        text: '10. Hostilidad',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b11',
        text: '11. Suspicacia',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b12',
        text: '12. Comportamiento alucinatorio',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b13',
        text: '13. Retardo motor',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b14',
        text: '14. Falta de colaboración',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b15',
        text: '15. Contenidos inusuales del pensamiento',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b16',
        text: '16. Embotamiento afectivo',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b17',
        text: '17. Excitación',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b18',
        text: '18. Desorientación',
        type: QuestionType.LIKERT,
        options: scale1to7
      }
    ],
    interpretations: [
      { min: 18, max: 31, label: 'Síntomas Mínimos', color: 'bg-green-100 text-green-800' },
      { min: 32, max: 45, label: 'Síntomas Leves', color: 'bg-yellow-100 text-yellow-800' },
      { min: 46, max: 58, label: 'Síntomas Moderados', color: 'bg-orange-100 text-orange-800' },
      { min: 59, max: 71, label: 'Síntomas Marcados', color: 'bg-orange-200 text-orange-900' },
      { min: 72, max: 126, label: 'Síntomas Severos', color: 'bg-red-200 text-red-900' }
    ]
  }
];
